<template>
  <div>
    <BaseHeader class="pb-6" type="default">
      <b-row align-v="center" class="py-4">
        <b-col>
          <p class="h2 text-white d-inline-block mb-0">Points de cueillette</p>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <RouteBreadcrumb />
          </nav>
        </b-col>
      </b-row>
    </BaseHeader>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="12">
          <PickingPointForm
            :on-success="save"
            title="Créer un point de cueillette"
            redirect="/establishments/pickingpoints/index"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { RouteBreadcrumb, BaseHeader } from '@coop-zone/coop-zone-argon'
import PickingPointForm from '@/components/PickingPoints/PickingPointForm'

export default {
  components: {
    PickingPointForm,
    RouteBreadcrumb,
    BaseHeader,
  },
  created() {
    this.$store.commit('pickingpoints/SET_PICKING_POINT', {})
  },
  methods: {
    async save() {
      await this.$store.dispatch('pickingpoints/createPickingPoint')
    },
  },
}
</script>
